export default "__VITE_PUBLIC_ASSET__06bc11b6__"